const SLIDE_DURATION = 300;

const setExpanded = ($, $item, $btn, $content, expanded) => {
    $item.toggleClass('is-expanded', expanded).toggleClass('is-collapsed', !expanded);
    $btn.attr('aria-expanded', expanded ? 'true' : 'false');

    const $label = $btn.find('.categoryList__toggleLabel');
    const labelKey = expanded ? 'expanded' : 'collapsed';
    const labelText = $label.data(labelKey);
    if (typeof labelText === 'string' && labelText.length > 0) {
        $label.text(labelText);
    }

    if (expanded) {
        $content.removeAttr('hidden').stop(true, true).slideDown(SLIDE_DURATION);
    } else {
        $content.stop(true, true).slideUp(SLIDE_DURATION, function () {
            $(this).attr('hidden', 'hidden');
        });
    }
};

export const initCategoryList = () => {
    if (typeof jQuery !== 'function') {
        return;
    }
    const $ = jQuery;
    const $lists = $('[data-component="category-list"]');
    if ($lists.length === 0) {
        return;
    }

    $lists.each(function () {
        const $list = $(this);

        $list.on('click', '.categoryList__toggle', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $item = $btn.closest('.categoryList__item');
            const panelId = $btn.attr('aria-controls');
            const $content = panelId ? $('#' + panelId) : $item.find('.categoryList__content').first();
            const expanded = $btn.attr('aria-expanded') === 'true';
            setExpanded($, $item, $btn, $content, !expanded);
        });
    });
};
